import { render, staticRenderFns } from "./TerritoryDependentLocality.vue?vue&type=template&id=10568dd2&"
import script from "./TerritoryDependentLocality.vue?vue&type=script&lang=ts&"
export * from "./TerritoryDependentLocality.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports